let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
import TableSettingView from "./TableSettingView.js";
import DiscountSettingView from "./DiscountSettingView.js";
import UserSettingView from "./UserSettingView.js";
import MenuSettingView from "./MenuSettingView.js";
import PaymentSettingView from "./PaymentSettingView.js";
import RestaurantSettingView from "./RestaurantSettingView.js";
import PrintSettingView from "./PrintSettingView.js";
import SalesExportView from "./SalesExportView.js";
import LicenseSettingView from "./LicenseSettingView.js";
import MembershipSettingView from "./MembershipSettingView.js";
import MembershipSchemeView from "./MembershipSchemeView.js";
let QueueResourceSettingView = require("./QueueResourceSettingView.js");
import SettingsNavigatorView from "./SettingsNavigatorView.js";
import BookingResourceSettingView from "./BookingResourceSettingView.js";
import POS from "../../POS.js"
import i18n from "../../utils/i18n";

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .menuList a": "anchorClicked"
        },
        currentView: null,

        render: function (type) {
            var settingType = type.type ? type.type : 'sales', result = $.post('/pos/settings', {section: settingType}), self = this,
                loading = this.$('.loading').clone().removeClass('hidden'), tooltips = self.options.tooltips, settingTag = type.tag ? type.tag : "";

            POS.showLoading(true);
            // hide sidebar if current page is on the settings navigator
            if (settingType == 'settingsNavigator') {
                self.$('.sidebar').hide();
                self.$('.mainArea').addClass('hideMainArea');
            } else {
                self.$('.sidebar').show();
                if (!window.AndroidClient) {
                    self.$('.sidebar .invoice').hide();
                }
                self.$('.mainArea').removeClass("hideMainArea");
            }
            result.done(function (html) {
                if (self.currentView && self.currentView.$el.hasClass("areaSetting")) {
                    self.currentView.remove();
                }
                self.$('.mainArea').empty().append(html);
                self.$('.sidebar a').removeClass('active');
                self.showSettingType(settingType, settingTag);

                //it's very important that after any change in settings, if a refresh is needed,
                //the setting subview needs to trigger the needRefresh event. This will make a
                //Dialog to show when user move away from the settings view to refresh the page
                self.listenTo(self.currentView, 'needRefresh', function () {
                    console.log('trgger need refresh event!');
                    self.trigger('needRefresh');
                });
            });

            result.fail(function (res) {
                self.$('.mainArea .loading').remove();
            });
            result.always(function(){
                POS.showLoading(false);
            });

            return this;
        },

        showSettingType(settingType, settingTag) {
            const self = this;
            let container;

            switch (settingType) {
                case "table":
                    self.currentView = new TableSettingView({el: self.$('.tableSetting')});
                    break;
                case "settingsNavigator":
                    self.currentView = new SettingsNavigatorView({el: $('#settingsNavigator')});
                    break;
                case "discount":
                    self.currentView = new DiscountSettingView({el: self.$('.discountSetting')});
                    break;
                case "user":
                    self.currentView = new UserSettingView({el: self.$('.userSetting')});
                    break;
                case "menu":
                    self.currentView = new MenuSettingView({el: self.$('.menuSetting')});
                    break;
                case "restaurant":
                    self.currentView = new RestaurantSettingView({el: self.$('.restaurantSetting')});
                    self.currentView.settingTag = settingTag;
                    break;
                case "print":
                    self.currentView = new PrintSettingView({el: self.$('.printSetting')});
                    break;
                case "sales":
                    self.currentView = new SalesExportView({el: self.$('.salesExport')});
                    self.currentView.settingTag = settingTag;
                    break;
                case "license":
                    self.currentView = new LicenseSettingView({el: self.$('.licenseContainer')});
                    self.currentView.settingTag = settingTag;
                    self.currentView.purchaseView = self.options.purchaseView;
                    break;
                case "membershipSetting":
                    if (POS.checkFeature("MEMBERSHIP")) {
                        self.currentView = new MembershipSettingView({el: self.$('.membershipContainer')});
                    } else {
                        alert(i18n.msg("pos.settings.not.have.membership.license"));
                        window.location.hash = "settings/license";
                    }
                    break;
                case "membershipSchemeSetting":
                    if (POS.checkFeature("MEMBERSHIP")) {
                        self.currentView = new MembershipSchemeView({el: self.$('.scheme-container')});
                    } else {
                        alert(i18n.msg("pos.settings.not.have.membership.license"));
                        window.location.hash = "settings/license";
                    }
                    break;
                case "bookingResource":
                    self.currentView = new BookingResourceSettingView({el: self.$('.bookingSetting')});
                    break;
                case "queueResource":
                    self.currentView = new QueueResourceSettingView({el: self.$('.queueSetting')});
                    break;
                case "payment":
                    self.currentView = new PaymentSettingView({el: self.$('.paymentSetting')});
                    break;
            }
            self.currentView.render();
            self.$('.sidebar .' + settingType).addClass('active');
        },

        anchorClicked: function (e) {
            window.location.href = $(e.currentTarget).attr("href");
            return false;
        }
    });
};

let exportedValue = main();

export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/SettingsView.js